// Globals
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// Store
import { useAppState } from '@/store';
import { selectPropertyOwner, selectStepsProgresses } from '../../feature';

// Models
import { DocumentsStepProgress } from '@/models/propertyProgress.model';
import { StepType } from '@/models/step.model';

// Components
import { ResetStepButton, StepCard, StyledButtonsWrap, StyledLabel, StyledRow, StyledText } from '../../components';
import { Button } from '@/ui';
import { ArrowRightIcon } from '@/icons';

// Helpers
import { finalStatuses, getStepUploader, PropertyTabs } from '../../helpers';

type TDocumentsProgressContainerProps = {
  hideResetButton?: boolean;
};

const DocumentsProgressContainer = ({ hideResetButton = false }: TDocumentsProgressContainerProps) => {
  const { t } = useTranslation('property');
  const stepsProgresses = useAppState(selectStepsProgresses);
  const propertyOwner = useAppState(selectPropertyOwner);
  const documentsProgress = stepsProgresses?.[StepType.DOCUMENTS] as DocumentsStepProgress;
  const [, setQueryParams] = useSearchParams();

  if (!documentsProgress) return null;

  const user = getStepUploader(documentsProgress);
  const goToDocuments = () => {
    setQueryParams((prev) => {
      prev.set('tab', PropertyTabs.DOCUMENTS);
      return prev;
    });
  };

  return (
    <StepCard title={t('step_documents')} status={documentsProgress.status}>
      <StyledRow>
        <div>
          {user && (
            <>
              <StyledLabel>{t('label_who_uploaded')}</StyledLabel>
              <StyledText>
                {t('property_upload_by', {
                  name: propertyOwner?.full_name,
                  context: user,
                })}
              </StyledText>
            </>
          )}
        </div>

        <StyledButtonsWrap>
          {!hideResetButton && finalStatuses.includes(documentsProgress.status) && (
            <ResetStepButton propertyId={documentsProgress?.property_id} stepName={StepType.DOCUMENTS} />
          )}
          <Button type="primary" shape="round" onClick={goToDocuments} icon={<ArrowRightIcon />} iconPosition={'end'}>
            {t('property_go_to_documents')}
          </Button>
        </StyledButtonsWrap>
      </StyledRow>
    </StepCard>
  );
};

export default DocumentsProgressContainer;
